// Single source of truth for an integration's connection status across every surface
// (Settings > Integrations, the campaign Integrations tab, and the Sales Account page).
// Driven by the universal `connectionStatus` field (active | needs_reconnect | pending_setup) + legacy Gmail OAuth.

export const getConnectionState = (integration) => {
  // Zapmail-purchased mailbox still being provisioned — activates automatically, never "reconnect"
  const isPendingSetup = integration?.['connectionStatus'] === 'pending_setup';
  // `connectionType === 'oauth'` only exists for legacy Gmail accounts that must migrate to App Password.
  const needsReconnect = !isPendingSetup && (integration?.['connectionStatus'] === 'needs_reconnect'
    || integration?.['connectionType'] === 'oauth');
  return {
    isPendingSetup,
    needsReconnect,
    label: isPendingSetup ? 'Setup Pending' : needsReconnect ? 'Needs Reconnect' : 'Active',
    tone: isPendingSetup ? 'pending' : needsReconnect ? 'error' : 'ok',
    title: isPendingSetup ? 'We are setting this mailbox up — it activates automatically' : needsReconnect ? (integration?.['connectionError'] || 'Needs Reconnect') : 'Connected',
  };
};
